import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";

import { withRouter } from "react-router-dom";
import { compose } from "redux";
import ProductSlipList from "./ProductSlipList";
import ProductSlipModal from "./ProductSlipModal";

import injectReducer from "helpers/injectReducer";
import injectSaga from "helpers/injectSaga";
import productSlipReducer from "store/ProductSlip/reducer";
import productSlipSaga from "store/ProductSlip/saga";

const productSlipKey = "ProductSlip";

const withProductSlipReducer = injectReducer({
  key: productSlipKey,
  reducer: productSlipReducer,
});
const withProductSlipSaga = injectSaga({
  key: productSlipKey,
  saga: productSlipSaga,
});

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productSlipDialog: false,
      productSlipData: null,
    };
  }

  handleOnViewProductSlip = (productSlipData) => {
    this.setState({
      productSlipDialog: true,
      productSlipData,
    });
  };

  closeModal = () => {
    this.setState({
      productSlipDialog: false,
      productSlipData: null,
    });
  };

  render() {
    return (
      <React.Fragment>
        <Container fluid className="pt-4">
          {this.state.productSlipDialog && (
            <ProductSlipModal
              productSlipDialog={this.state.productSlipDialog}
              closeModal={this.closeModal}
              productSlipRecord={this.state.productSlipData}
            />
          )}
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between">
                    <h4 className="mt-0 page-title">Product Slip</h4>
                  </div>

                  <ProductSlipList
                    onViewProductSlip={this.handleOnViewProductSlip}
                    closeModal={this.closeModal}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default compose(
  withProductSlipReducer,
  withProductSlipSaga,
  withRouter
)(Index);
